module.exports = __webpack_public_path__ + "img/branding-settings.afad2322.png";